import styled from "styled-components";
import { LiveCasinoNavbarCipBox } from "./live-casino-navbar.cip.box";

export const LiveCasinoNavbarMrGreenCisBox = styled(LiveCasinoNavbarCipBox)`
    border-bottom: none;
`;
